module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.detailShow) ? _c('div', {
    attrs: {
      "id": "more-detail"
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('a', {
    on: {
      "click": _vm.goBack
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icon/iamge_nav_cancel@3x.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('h1', [_vm._v("Notice")])]), _vm._v(" "), _c('div', {
    staticClass: "title clearfix"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icon/image_faq_detail@3x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.contentData.title))])]), _vm._v(" "), _vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom"
  }, [_c('p', [_vm._v("Switch Off the \"Private Account\" in the Settings of Instagram app.")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/icon/image_private_guide@3x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("Your posts will receive likes and views only when your account is public. So you need to make sure you aren't using a private profile.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a6e9800a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/LoginDetail.vue
// module id = 271
// module chunks = 18